import BaseMystery from '../BaseMystery'

const FourthSorrow = () => {
	const imagesList = [
		//"https://www.meisterdrucke.ie/kunstwerke/1260px/Bartolom%20Esteban%20Murillo%20-%20Christ%20at%20Calvary%20%20-%20%28MeisterDrucke-64740%29.jpg",
		"https://www.meisterdrucke.ie/kunstwerke/1260px/Hippolyte_Flandrin_-_Christ_carrying_his_cross_Detail_of_a_fresco_by_Hyppolithe_Flandrin_%281800-1864%29_-_%28MeisterDrucke-1057566%29.jpg",
	];

	const titleText = "Mary meets Jesus with the Cross";
	const scriptureQuote = "\"Indeed, the days are coming when people will say, 'Blessed are the barren, the wombs that never bore and the breasts that never nursed.'\"";
	const scriptureCitation = "Luke 23:29 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%2023%3A27-31&version=NABRE";

	return (
		<BaseMystery titleText={titleText}
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default FourthSorrow;